import axios from "axios";
import M from "materialize-css";
/**
 *  Sets the document body overflow property
 *
 * @param value the value to set overflow property to.
 *
 */
export const setDocumentBodyOverflowProperty = (value = "auto") => {
  document.body.style.overflow = value;
};

// config = {
//     path ? : string;
//     method ? : "GET" | "POST" | "DELETE" | "PUT";
//     data ? : any;
//     header ? : any;
// }

//const APP_URL = `http://localhost:3000`/*'http://192.168.1.198:3000' "http://localhost:3000" */
//const APP_URL = "http://localhost:3000";
export const APP_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : `https://sldb.lc`;
//export const APP_URL = `http://localhost:3000`;

/**
 *  axios request
 * @param config path | method | data | header
 */
export const Request = async (config) => {
  return await axios({
    url: `${APP_URL}${config.path}`,
    method: config.method,
    data: config.data,
    headers: {
      // "Content-Type": "application/json, text/plain",
      ...config.header,
    },
  });
};

/**
 * Generates a username from user's first and last name
 * @param {string} email string email
 */
export const generateUsername = (email) => {
  const first = email.split("@")[0];
  const nonAlpha = first.replace(/[\W_]+/g, " ");
  const name = nonAlpha.replace(/\s+/g, "");
  const random = Math.floor(Math.random() * Math.floor(999));
  return `${name}${random}`;
};

export const setCookie = (cname, cvalue, exdays) => {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const dismissToast = () => {
  try {
    M.Toast.dismissAll();
  } catch (err) {
    return err;
  }
};

export const toastMessage = (message, callback, listener, c) => {
  let instance = null;
  let cs = c ? c : "has-bottom-nav";
  dismissToast();
  M.toast({
    html: message,
    classes: cs,
    completeCallback: () => {
      callback ? callback() : "";
      if (listener) {
        instance = null;
      }
    },
  });

  if (listener)
    setTimeout(() => {
      instance = document
        .querySelector(".toast-action")
        .addEventListener("click", listener);
    }, 400);
};
